<script setup lang="ts">
// import MainPage from '@/views/MainPage/index.vue'
import { RouterView } from 'vue-router'
</script>

<template>
  <!--<MainPage></MainPage>-->
  <RouterView />
</template>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  /*
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
   */
}
/*
nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
 */

/* 全局滚动条样式 */

/* Chrome / Edge / Safari */
::-webkit-scrollbar {
  width: 2px; /* 垂直滚动条宽度 */
  height: 2px; /* 水平滚动条高度 */
}

::-webkit-scrollbar-track {
  background: transparent; /* 轨道透明，降低存在感 */
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1); /* 半透明黑，低存在感 */
  border-radius: 4px; /* 圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.35); /* hover 更清晰 */
}

/* Firefox */
* {
  scrollbar-width: thin; /* 滚动条细 */
  scrollbar-color: rgba(0, 0, 0, 0.06) transparent; /* thumb颜色 + track颜色 */
}
</style>
